import styled from "styled-components";
import { Modal as AntdModal, Row } from "antd";
import { Title as SundayTitle, Body as SundayBody } from "sunday-component";
import { color } from "src/styles/globals";

export const Modal = styled(AntdModal)`
  top: 0;
  margin: 0px;
  padding: 0px;
  max-width: 333px;
  .ant-modal-content {
    text-align: center;
    padding: 0px;
    border-radius: 16px;
    overflow: hidden;
  }
  .ant-modal-header {
    padding: 24px 0px;
    border: none;
  }
  .ant-modal-body {
    padding: 0px 16px;
    overflow: auto;
  }
  .ant-modal-footer {
    border: none;
    padding: 16px;
  }
`;
export const ModalBody = styled(SundayBody)`
  color: ${color.charcoal09};
`;
export const Title = styled(SundayTitle)`
  color: ${color.charcoal10};
`;
export const ContactLink = styled(SundayTitle).attrs({
  level: 7,
})`
  color: var(--ui-form-button-text-enabled-text-color);
`;
export const IconContainer = styled.div`
  margin: 8px 0px;
  color: var(--ui-form-button-text-enabled-text-color);
`;
export const ContactContainer = styled.div`
  margin: 16px 0px;
`;
export const ContactItem = styled(Row).attrs({ gutter: 16 })`
  padding: 8px 16px;
`;
